"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const About_1 = require("../../frontend/components/About");
const Home_1 = require("../../frontend/components/Home");
const Blog_1 = require("../../frontend/components/Blog");
const SinglePost_1 = require("../../frontend/components/SinglePost");
const BlogActions_1 = require("../../frontend/actions/BlogActions");
const EntitiesActions_1 = require("../../frontend/actions/EntitiesActions");
const Resume_1 = require("../../frontend/components/Resume");
const Portfolio_1 = require("../../frontend/components/Portfolio");
const ExtraStore_1 = require("../../frontend/stores/ExtraStore");
exports.default = {
    home: {
        path: '/',
        isInMenu: true,
        method: 'get',
        page: 'home',
        title: '{0}',
        handler: Home_1.default,
        action: (context, payload, done) => {
            context.executeAction(EntitiesActions_1.default.getEntities, { action: ExtraStore_1.TESTIMONIAL_RECEIVED, resource: 'testimonials' }, done);
        },
    },
    resume: {
        path: '/resume',
        isInMenu: true,
        method: 'get',
        page: 'resume',
        title: 'Resume - {0}',
        handler: Resume_1.default,
    },
    blog: {
        path: '/blog',
        isInMenu: true,
        method: 'get',
        page: 'blog',
        title: 'Blog posts - {0}',
        handler: Blog_1.default,
        action: (context, payload, done) => {
            context.executeAction(BlogActions_1.default.getPosts, payload.query, done);
        },
    },
    posts: {
        path: '/post',
        isInMenu: false,
        method: 'get',
        page: 'posts',
        title: 'Blog',
        handler: Blog_1.default,
        action: (context, payload, done) => {
            context.executeAction(BlogActions_1.default.getPosts, payload.query, done);
        },
    },
    post: {
        path: '/post/:slug',
        method: 'get',
        page: 'singlePost',
        title: 'SinglePost',
        handler: SinglePost_1.default,
        action: (context, payload, done) => {
            context.executeAction(BlogActions_1.default.getCurrentPost, {
                slug: payload.params.slug,
            }, done);
        },
    },
    portfolio: {
        path: '/portfolio',
        isInMenu: true,
        method: 'get',
        page: 'portfolio',
        title: 'Work - {0}',
        handler: Portfolio_1.default,
        action: (context, payload, done) => {
            context.executeAction(EntitiesActions_1.default.getEntities, { action: ExtraStore_1.WORKS_RECEIVED, resource: 'works' }, done);
        },
    },
    contact: {
        path: '/contact',
        isInMenu: true,
        method: 'get',
        page: 'contact',
        title: 'Contact - {0}',
        handler: About_1.default,
    },
};
